import React from 'react';
import { Layout } from '@philips-internal/oswald-ui-components';
import { ReactEngineBridge } from '@philips-internal/oswald-ui-engine';
import { parseGridTrackList } from '@philips-internal/oswald-ui-utils';
const LayoutEditor = ReactEngineBridge(function LayoutEditor(props) {
    const columnsArray = parseGridTrackList(props.columns);
    const rowsArray = parseGridTrackList(props.rows);
    const rowElements = rowsArray.map((_, index) => {
        if (index) {
            const style = {
                gridArea: `${index + 1} / 1 / ${index + 2} / -1`,
                height: props.rowGap,
            };
            return (React.createElement("div", { className: "resizer resizer--row", key: index, style: style }));
        }
        return null;
    });
    const columnElements = columnsArray.map((_, index) => {
        if (index) {
            const style = {
                gridArea: `1 / ${index + 1} / -1 / ${index + 2}`,
                width: props.columnGap,
            };
            return (React.createElement("div", { className: "resizer resizer--column", key: index, style: style }));
        }
        return null;
    });
    return (React.createElement(Layout, { ...props },
        rowElements,
        columnElements,
        props.children));
});
export { LayoutEditor, };
//# sourceMappingURL=layout-editor.js.map